;(function () {
  function init() {
    var els = document.querySelectorAll('.stat-number[data-count-to]')
    if (!els.length) return

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    function cascadeExtra(el) {
      var group = el.closest('.stat-pair') || el.parentElement
      if (!group) return 0
      var siblings = Array.prototype.slice.call(group.querySelectorAll('.stat-number[data-count-to]'))
      if (siblings.length < 2) return 0
      siblings.sort(function (a, b) {
        return parseInt(b.getAttribute('data-count-to'), 10) - parseInt(a.getAttribute('data-count-to'), 10)
      })
      var index = siblings.indexOf(el)
      return index * 350
    }

    function startValue(el) {
      return Math.round(parseInt(el.getAttribute('data-count-to'), 10) / 2)
    }

    function animate(el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10)
      if (reduceMotion) {
        el.textContent = target + '%'
        return
      }
      var runId = (el._countRunId || 0) + 1
      el._countRunId = runId
      var from = startValue(el)
      el.textContent = from + '%'
      var duration = 1800 + cascadeExtra(el)
      var start = null
      function step(ts) {
        if (el._countRunId !== runId) return
        if (start === null) start = ts
        var progress = Math.min((ts - start) / duration, 1)
        var eased = 1 - Math.pow(1 - progress, 3)
        el.textContent = Math.round(from + eased * (target - from)) + '%'
        if (progress < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }

    function reset(el) {
      el._countRunId = (el._countRunId || 0) + 1
      el.textContent = startValue(el) + '%'
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(animate)
      return
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target)
          } else {
            reset(entry.target)
          }
        })
      },
      { threshold: 0.6 }
    )

    els.forEach(function (el) {
      observer.observe(el)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
